import React from "react";

import Logo1 from "../../../assets/TimeLineLogo/Logo1.svg";
import Logo2 from "../../../assets/TimeLineLogo/Logo2.svg";
import Logo3 from "../../../assets/TimeLineLogo/Logo3.svg";
import Logo4 from "../../../assets/TimeLineLogo/Logo4.svg";
import timelineImage from "../../../assets/Images/TimelineImage.png";

const timeline = [
  {
    Logo: Logo1,
    heading: "Leadership",
    Description: "Fully committed to the success company",
  },
  {
    Logo: Logo2,
    heading: "Responsibility",
    Description: "Students will always be our top priority",
  },
  {
    Logo: Logo3,
    heading: "Flexibility",
    Description: "The ability to switch is an important skills",
  },
  {
    Logo: Logo4,
    heading: "Solve the problem",
    Description: "Code your way to a solution",
  },
];

function TimelineSection(props) {
  return (
    <div className="mb-14">
      <div className="flex max-[447px]:flex-col md:flex-rol gap-14 items-center">
        <div className="flex flex-col lg:w-[45%] gap-5">
          {timeline.map((element, index) => {
            return (
              <div className="flex gap-6 relative timeline-container py-1" key={index}>
                <div className="w-[60px] h-[60px] timeline-item px-4 justify-center rounded-full flex z-10 items-center  bg-white shadow-lg hover:scale-95 transition-all duration-200">
                  <img src={element.Logo} width={39} alt="" />
                </div>
                <div className="w-1 h-20 absolute -bottom-6 left-6 z-0"></div>
                <div className="flex flex-col">
                  <div className="font-semibold text-[18px]">
                    {element.heading}
                  </div>
                  <div className="text-base">{element.Description}</div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="relative ">
          <img
            className="rounded-md object-cover h-fit z-10 inset-20 bg-indigo-500 shadow-[rgba(255,255,255,1)_20px_25px_2px_0px]"
            src={timelineImage}
            alt="timelineimage"
          />
          {/* <div className='w-[100%] absolute rounded-full opacity-25 z-0 h-[100%] inset-20 bg-indigo-500 shadow-[rgba(0,191,255,1)_5px_70px_50px_50px]'>

                    </div> */}
          {/* <div className='shadow-[0px_10px_40px_6px_#9CECFB,0px_3px_10px_5px_#65C7F7,0px_-1px_25px_2px_#0052D4] w-[98%] h-[80%] absolute top-7 left-2 rounded-full'>

                    </div> */}
        <div className="absolute bg-caribbeangreen-700 flex text-white uppercase py-7 left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-md">
            <div className="flex gap-5 items-center border-r border-caribbeangreen-300 px-7 max-[450px]:px-2">
                <p className="text-3xl font-bold">10</p>
                <p className="text-sm font-bold text-caribbeangreen-300">Years of Experience</p>
            </div>
            <div className="flex gap-5 items-center px-7 max-[450px]:px-2">
            <p className="text-3xl font-bold">250</p>
                <p className="text-sm font-bold text-caribbeangreen-300">Typpe of courses</p>
            </div>
        </div>
        </div>
      </div>
    </div>
  );
}

export default TimelineSection;
